import React from 'react'
import qs from 'query-string'

import {
  useApplicationState,
  SportManager,
  useSettings,
  SubscriptionManager,
  EventContext,
  createEventState,
  eventInitialState,
  actions,
  logger, Bus
} from '@apollo/core'
import {RouteComponentProps, withRouter} from "react-router-dom";

export const SelectedEventQueryRoute = withRouter(
  (props) => {
    const {
      location,
      children
    } = props

    const selectedEventIdParam = React.useMemo(
      () => {
        const params = qs.parse(location.search)

        return params.e
      },
      [location.search]
    )

    if (selectedEventIdParam) {
      return (
        <SelectedEventQueryProvider eventId={selectedEventIdParam}>
          {children}
        </SelectedEventQueryProvider>
      )
    }

    return null
  }
)

function SelectedEventQueryProvider (props) {
  const {
    children,
    eventId
  } = props

  const { connection } = useApplicationState()

  const [
    eventState,
    eventDispatcher
  ] = createEventState()

  const {
    lang
  } = useSettings()

  /*
    Subscribing (to DataUpdatesBroadcaster) for event updates
  */
  React.useEffect(
    () => {
      if (!eventState.id) {
        return
      }

      // Subscription topics for selected event
      const eventSubscriptionTopics = [
        {
          topic: SubscriptionManager.subscriptionTopics.EXPERIMENTAL_EVENT,
          key: eventState.id
        }
      ]

      // External subscription on Notifier Service
      SubscriptionManager.notifierSubscribe(eventSubscriptionTopics)

      return () => {
        // External subscription on Notifier Service
        SubscriptionManager.notifierUnsubscribe(eventSubscriptionTopics)
      }
    },
    [eventState.id]
  )

  React.useEffect(
    () => {
      if (!eventId) {
        logger.debug('[event:selected] waiting for initialization')
        return
      }

      logger.debug('[event:selected]', `fetching event #${eventId}`)

      eventDispatcher({
        type: actions.EVENT_STATE_UPDATE,
        payload: {
          loading: true,
          error: null
        }
      })

      SportManager.findEvent(eventId)
        .then((event) => {

          // Setting new event data
          eventDispatcher({
            type: actions.EVENT_SET,
            payload: {
              ...event,
              initialized: true,
              loading: false
            }
          })

          Bus.emit(Bus.events.sport.sportEventUpdate, event)
        })
        .catch((error) => {
          logger.error('[event:selected]', `unable to fetch event #${eventId}`, error)

          eventDispatcher({
            type: actions.EVENT_STATE_UPDATE,
            payload: {
              error,
              initialized: true,
              loading: false
            }
          })
        })
    },
    [connection.id, lang, eventId]
  )

  return (
    <EventContext.Provider value={eventState}>
      {children}
    </EventContext.Provider>
  )
}
